export var OPERATOR_FILTER_MAP = { Equal: '_eq', Different: '_neq', BiggerOrEqual: '_gte', LessOrEqual: '_lte', Less: '_lt', Bigger: '_gt' };
